import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Typography } from '@mui/material';

const apiUrlId = process.env.REACT_APP_API_RESERVAS_ID;

const EstadoReserva = ({ reservaId }) => {
  const [estado, setEstado] = useState('Cargando...');

  useEffect(() => {
    const fetchEstado = async () => {
      try {
        const res = await axios.get(`${apiUrlId}${reservaId}`);
        const miembros = res.data.miembros || [];
        const total = miembros.length;
        const conHabitacion = miembros.filter(m => m.habitacion_asignada).length;
        const tieneReservaQlo = res.data.reserva_qloapp || miembros[0]?.reserva_qloapp;

        if (total === 0) setEstado('Sin miembros');
        else if (conHabitacion === total && tieneReservaQlo) setEstado('Completa');
        else if (conHabitacion > 0 || tieneReservaQlo) setEstado('Parcial');
        else setEstado('Vacía');
      } catch (error) {
        console.error('❌ Error al calcular estado de carga:', error);
        setEstado('Error');
      }
    };

    fetchEstado();
  }, [reservaId]);

  const colorMap = {
    'Completa': '#c8e6c9',
    'Parcial': '#fff9c4',
    'Vacía': '#ffcdd2',
    'Sin miembros': '#eeeeee',
    'Error': '#ffccbc',
    'Cargando...': '#f0f0f0',
  };

  const textColorMap = {
    'Completa': '#2e7d32',
    'Parcial': '#f57f17',
    'Vacía': '#c62828',
    'Sin miembros': '#616161',
    'Error': '#bf360c',
    'Cargando...': '#616161',
  };

  return (
    <Typography
      sx={{
        fontWeight: 'bold',
        px: 1,
        borderRadius: 1,
        backgroundColor: colorMap[estado],
        color: textColorMap[estado],
      }}
    >
      {estado}
    </Typography>
  );
};

export default EstadoReserva;
